import { EventInfo, EventWithTeams } from '@/api/events/types/types';
import { useLeagueConfigsStore } from '@/feature/betslip-pickem/hooks/use-league-configs-store';
import { EventStatus } from '@/types/api.generated';
import { nflFullSeason } from '@/utils/league';

import { useJurisdictionStore } from './use-jurisdiction';

const notStartedStatus = [EventStatus.Scheduled, EventStatus.Delayed];

export const useEventSupportsScoreboard = (event?: EventWithTeams | EventInfo) => {
    const scoreboardEnabled = useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.settings?.scoreboard_enabled
    );
    const leagueConfigs = useLeagueConfigsStore(state => state.leagueConfigs);
    const pamEventId = event?.dataFeedSourceIds.find(({ source }) => source === 'PAM')?.id ?? '';
    const leagueSupportsScoreboard = leagueConfigs.find(
        leagueConfig => leagueConfig.league === event?.league
    )?.liveMarketsEnabled;
    const isFullSeason = nflFullSeason(event?.league);
    const isFutureEvent = notStartedStatus.includes(event?.status || EventStatus.Scheduled);
    return leagueSupportsScoreboard && !isFullSeason && pamEventId && !isFutureEvent && scoreboardEnabled;
};
